import React, { useEffect, useState } from 'react';
import styles from './Toast.module.css';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastProps {
  message: string;
  type: ToastType;
  isVisible: boolean;
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, type, isVisible, onClose }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      // Small delay to ensure the element is rendered before animation
      const showTimer = setTimeout(() => {
        setIsAnimating(true);
      }, 10);
      
      const hideTimer = setTimeout(() => {
        setIsAnimating(false);
        // Wait for exit animation to complete before unmounting
        setTimeout(() => {
          setShouldRender(false);
          onClose();
        }, 400); // Match the CSS transition duration
      }, 3000);

      return () => {
        clearTimeout(showTimer);
        clearTimeout(hideTimer);
      };
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!shouldRender) return null;

  return (
    <div className={`${styles.toast} ${styles[type]} ${isAnimating ? styles.show : ''}`}>
      <div className={styles.content}>
        <span className={styles.message}>{message}</span>
        <button onClick={() => {
          setIsAnimating(false);
          setTimeout(() => {
            setShouldRender(false);
            onClose();
          }, 400);
        }} className={styles.closeButton}>×</button>
      </div>
    </div>
  );
};
